import { global_promo_banner } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type PromoBannerProps } from './PromoBanner';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';

export const promoBannerSchema =
  global_promo_banner.transform<PromoBannerProps>(data => ({
    content: data.content,
    headline: data.headline,
    variant: data.variant,
    ctaHref: data.cta_href,
    ctaText: data.cta_text,
    images: data.images.map<PromoBannerProps['images'][number]>(image =>
      getCloudinaryImageFields({
        alt: image.alt,
        cloudinaryField: image.src,
        shouldUseV2: true,
      }),
    ),
  }));
